import { styled } from "@mui/material/styles";
import { Card, Typography, Box } from "@mui/material";

export const Container = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  padding: theme.spacing(4),
  backgroundColor: theme.palette.grey[100],
  minHeight: "100vh",
}));

export const EmployeeCard = styled(Card)(({ theme }) => ({
  width: "100%",
  maxWidth: 1100,
  borderRadius: Number(theme.shape.borderRadius) * 2,
  padding: theme.spacing(4),
  boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
  background: `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${theme.palette.grey[50]} 100%)`,
  display: "flex",
  flexDirection: "column",
}));

export const HighlightSection = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "stretch",
  marginBottom: theme.spacing(4),
  gap: theme.spacing(3),
}));

export const HighlightBox = styled(Box)(({ theme }) => ({
  flex: "1 1 auto",
  padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.grey[50],
  border: `1px solid ${theme.palette.divider}`,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  minWidth: 0,
}));

export const HighlightLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: "0.75rem",
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(0.25),
  textTransform: "uppercase",
  letterSpacing: "0.5px",
}));

export const HighlightValue = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: "1.1rem",
  color: theme.palette.text.primary,
}));

export const HighlightName = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: "1.75rem",
  color: theme.palette.text.primary,
}));

export const HighlightSubInfo = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  "& .MuiTypography-root": {
    marginTop: theme.spacing(0.5),
  },
}));

export const InfoRow = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(0.25, 0),
}));

export const Label = styled(Typography)(({ theme }) => ({
  fontSize: "0.65rem",
  fontWeight: 600,
  color: theme.palette.grey[700],
  textTransform: "uppercase",
  letterSpacing: "0.6px",
  marginBottom: theme.spacing(0.15),
}));

export const Value = styled(Typography)(({ theme }) => ({
  fontSize: "0.95rem",
  fontWeight: 500,
  color: theme.palette.text.primary,
}));

export const GroupsWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: theme.spacing(1),
  marginTop: theme.spacing(0.5),
  "& .group-item": {
    fontSize: "0.8rem",
    color: theme.palette.text.secondary,
    background: "transparent",
  },
}));

export const RawDataBlock = styled("pre")(({ theme }) => ({
  backgroundColor: theme.palette.grey[900],
  color: theme.palette.grey[100],
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  fontSize: "0.85rem",
  overflowX: "auto",
}));

export const WidgetRow = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
  gap: theme.spacing(3),
  width: "100%",
  marginTop: theme.spacing(4),
  paddingTop: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`,
}));

export const TopRow = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  alignItems: "flex-start",
  marginBottom: theme.spacing(2),
}));

export const NameRow = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  alignItems: "baseline",
  gap: theme.spacing(0.5),
  width: "100%",
}));

export const NameBlock = styled(Box)(({ theme }) => ({
  flex: "0 0 40%",
  minWidth: 220,
  padding: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
}));

export const NameFirst = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: "1.5rem",
  lineHeight: 1.05,
  overflowWrap: "anywhere",
  color: theme.palette.text.primary,
}));

export const NameLast = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: "1.5rem",
  lineHeight: 1.05,
  marginTop: 0,
  overflowWrap: "anywhere",
  color: theme.palette.text.primary,
}));

export const InfoBlock = styled(Box)(({ theme }) => ({
  flex: "1 1 auto",
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2, 3),
  boxSizing: "border-box",
  border: `1px solid ${theme.palette.divider}`,
}));

export const InfoGrid = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
  gap: theme.spacing(1.5),
  alignItems: "start",
}));

export const InfoColumnGrid = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.75),
}));

export const GroupsColumn = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.75),
  backgroundColor: "transparent",
  paddingLeft: theme.spacing(0.5),
}));
